import config from '../config';
import { clampTextToDimensions } from '../utils';

let soundManager;

class Intro extends Phaser.Scene {
  init () {
    // console.log('Intro.init');
    let g = this;
    soundManager = g.scene.get('SoundManager');
    soundManager.playMusic('loop-intro');

    g.sys.game.dataManager.setSessionItem(config.BASE_SCENE, 'Intro');
  }
  create () {
    // console.log('Intro.create');
    let g = this;

    g.add.sprite(config.CENTER_X, config.CENTER_Y, 'intro-bg');
    let cyborgFull = g.add.sprite(config.CENTER_X, config.CENTER_Y + 560, 'intro-cyborg-full');
    // let cyborg = g.add.sprite(config.CENTER_X, config.CENTER_Y + 350, 'intro-cyborg');
    let vortext = g.add.sprite(config.CENTER_X - 30, config.CENTER_Y + 80, 'intro-vortext');

    let body = g.add.sprite(config.CENTER_X - 30, config.CENTER_Y + 80, 'intro-body');
    body.play('intro-body');
    body.setScale(1);
    body.setAngle(-15);
    let legs = g.add.sprite(config.CENTER_X - 30, config.CENTER_Y + 80, 'intro-legs');
    legs.play('intro-legs');
    legs.setScale(1);
    legs.setAngle(-15);

    let group = [];

    group.push(body);
    group.push(legs);

    let timeline = g.tweens.createTimeline();

    timeline.add({
      targets: group,
      angle: '5',
      scaleX: 0.5,
      scaleY: 0.5,
      duration: 1000,
      ease: 'Back.easeOut'
    });

    timeline.add({
      targets: group,
      angle: -5,
      duration: 3000,
      'ease': 'Quad.easeOut'
    });

    timeline.add({
      targets: group,
      angle: 5,
      repeat: -1,
      yoyo: true,
      duration: 3000,
      'ease': 'Quad.easeInOut'
    });

    timeline.play();

    g.tweens.add({
      targets: vortext,
      angle: '360',
      repeat: -1,
      duration: 10000,
      'ease': 'Linear'
    });
    
    // bottom anchored
    // let playBtn = g.add.sprite(config.CENTER_X, config.CENTER_Y + 280, 'intro-play-btn');
    let playBtn = g.add.sprite(config.CENTER_X, config.HEIGHT - 230, 'intro-play-btn');
    let playText = g.add.text(playBtn.x, playBtn.y + 20, g.game.localisationManager.GetString("play"), { fontFamily: "FredBurger Black", fontSize: (76) +"px", color: "#5ef040", align: 'center' })
    playText.setOrigin(0.5);
    playText.setStroke('#000', 12);
    clampTextToDimensions(playText, 200, 100);
      
    let boltLeft = g.add.sprite(config.CENTER_X - 270, config.HEIGHT - 170, 'intro-bolt-left');
    let boltRight = g.add.sprite(config.CENTER_X + 270, config.HEIGHT - 170, 'intro-bolt-right');
    
    let brandLogo = g.add.sprite(config.CENTER_X + 270, config.HEIGHT - 80, 'brand-logo');
    let cnLogo = g.add.sprite(config.CENTER_X - 270, config.HEIGHT - 80, 'cn-logo');
    // let textScore = g.add.sprite(config.CENTER_X, config.HEIGHT - 50, 'intro-text-score');

    if (g.sys.game.dataManager.getHighScore() !== 0) {      
      let textBest = g.add.text(config.CENTER_X, config.HEIGHT - 100, g.game.localisationManager.GetString("best"), { fontFamily: "FredBurger Black", fontSize: (28) +"px", color: "#000", align: 'center' })
      textBest.setOrigin(0.5);
      textBest.setStroke('#FFF', 3);
      clampTextToDimensions(textBest, 300, 100);

      let score = g.add.text(config.CENTER_X, config.HEIGHT - 52, g.game.localisationManager.language != "ar" ? g.sys.game.dataManager.getHighScore().toLocaleString(g.game.localisationManager.language) : g.sys.game.dataManager.getHighScore(), { fontFamily: "FredBurger Black", fontSize: (56) +"px", color: "#ffef00", align: 'center' })
      score.setOrigin(0.5);
      score.setStroke('#000', 8);
      clampTextToDimensions(score, 400, 100);
    }
    
    let logo;

    if (config.HEIGHT <= 1024) {
      logo = g.add.sprite(config.CENTER_X, config.CENTER_Y - 330, 'intro-logo');
    } else {
      logo = g.add.sprite(config.CENTER_X, 100, 'intro-logo');
      logo.setOrigin(0.5, 0);
    }
    logo.x -= 2;

    let settingsBtn = g.add.sprite(config.WIDTH - 80, 80, 'settings-sprite');
    settingsBtn.setFrame('btn-settings.png');

    playBtn.setInteractive();

    playBtn.on('pointerdown', () => {
      soundManager.playSound('btn-play');
      g.scene.start('Play', { isContinue: false, queuedPause: false, queuedPowerUp: false });
    });

    settingsBtn.setInteractive();
    settingsBtn.on('pointerdown', () => {
      g.scene.launch('Settings');
    });

    g.events.off('resume');
    g.events.on('resume', (a, data) => {
      console.log('On Intro Resume!!!');
      soundManager.resumeMusic();
    });
    
    g.game.scale.refresh();
  }
}

export default Intro;
